import styled from '@emotion/styled';
import { A, Footer as ToolkitFooter } from 'toolkit/components';
import { Styles } from 'toolkit/components';

const PageFooter = styled.div`
  padding-top: 100px;
`;

const ContentWrapper = styled.div`
  z-index: 20;
  background: #fff;
  position: absolute;
  /* bottom: 0; */
  max-width: none;
  -webkit-box-shadow: 0 0 2px 0 ${Styles.colors.grey.secondaryDark};
  box-shadow: 0 0 2px 0 ${Styles.colors.grey.secondaryDark};
  width: 100%;
  clear: both;
`;

const FooterWrapper = styled.div`
  background: rgb(255, 255, 255);
  font-size: 12px;
  max-width: none;
  padding: 10px 20px;
  height: 50px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
`;

const Footer = () => {
  const config = {
    copyright: 'Contently',
    listItems: [
      // placeholder for <LocalizeLanguageSelector/> - waiting on graphql
      () => <></>,
      () => (
        <A href="/terms" title="Terms of Service">
          Terms of Service
        </A>
      ),
      () => (
        <A href="/privacy-policy" title="Privacy Policy">
          Privacy Policy
        </A>
      ),
      () => (
        <A href="https://support.contently.com/" title="Help">
          Help
        </A>
      ),
    ],
  };

  return (
    <PageFooter>
      <ContentWrapper>
        <FooterWrapper>
          <ToolkitFooter config={config} />
        </FooterWrapper>
      </ContentWrapper>
    </PageFooter>
  );
};

export default Footer;
